// Who the browser's stored data belongs to.
//
// Everything persisted for a user (the API cache, the selected workspace) is
// keyed by the signed-in user's `sub`, so a second person on the same browser
// never reads the first person's entries. The subject is the session's
// `user.sub`; only with auth disabled (local testing with a bypass email) is
// it the stored email.

import { session } from "../auth/session";
import { getAuthEnabled } from "../settings";

/** The subject of the signed-in user, or null. */
export function currentSubject(): string | null {
  const sub = session.getState().user?.sub;
  if (sub) return sub;
  if (getAuthEnabled()) return null;
  try {
    const email = localStorage.getItem("userEmail");
    return email ? `email:${email.toLowerCase()}` : null;
  } catch {
    return null;
  }
}

/** A storage-safe form of a subject, for use inside a key. */
export function scopeId(subject: string): string {
  return encodeURIComponent(subject);
}
